<div class="status-dropdown-container">

  <div class="status-display" (click)="toggle($event)"
    [ngStyle]="{'background-color': isActive ? '#404040' : statusColor}">
    <svg width="17" height="13" viewBox="0 0 17 13" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M15.7502 6.04918L7.75016 0.75L7.75016 3.75C0.75 5.25 0.75 12.25 0.75 12.25C0.75 12.25 3.75 8.25 7.75016 8.75L7.75016 11.85L15.7502 6.04918Z"
        stroke="white" stroke-width="1.5" stroke-linejoin="round" />
    </svg>
    {{ label }}
    <!-- Optional: Add a loading indicator -->
    <!-- <span *ngIf="isProcessing" style="margin-left: 5px;">...</span> -->
  </div>

  <div #menu class="status-dropdown-menu" [class.show]="showDropdown" (click)="$event.stopPropagation()">
    <button class="status-option" (click)="onExport('csv')" [disabled]="isProcessing">
      
       <span *ngIf="!isProcessing">Export to Excel</span>
      <!-- Optional: Add loading text -->
      <span *ngIf="isProcessing"> Exporting...</span>
    </button>

    <!-- <div class="status-option" (click)="onExport('pdf')" [class.disabled]="isProcessing">
      PDF
    </div> -->
  </div>

  <div class="status-backdrop" *ngIf="showDropdown" (click)="close()"></div>

</div>